import { ServerError, ServerParseError } from '@apollo/client';
import { ErrorResponse } from '@apollo/client/link/error';

type NetworkError = ErrorResponse['networkError'];

export function isServerParseError(err: NetworkError): err is ServerParseError {
  if (!err) {
    return false;
  }

  return 'name' in err && err.name === 'ServerParseError';
}

export function isServerError(err: NetworkError): err is ServerError {
  if (!err) {
    return false;
  }

  return 'name' in err && err.name === 'ServerError';
}

export function isCloudflareChallengeError(err: NetworkError): err is ServerParseError {
  if (!isServerParseError(err)) {
    return false;
  }

  if (err.statusCode !== 403) {
    return false;
  }

  return err.bodyText.includes('captcha-bypass') || err.bodyText.includes('keep DigitalOcean bot-free');
}

export function isEdgePermissionDeniedError(err: NetworkError): err is ServerParseError {
  return !!err && 'name' in err && err.name === 'PermissionDeniedError';
}
